var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-wrapper"},[_c('router-link',{staticClass:"btn",class:_vm.width,attrs:{"to":_vm.to}},[_c('img',{staticClass:"blade",attrs:{"src":require("@/assets/weapons/BladeRotate.svg")}}),_c('div',{staticClass:"text"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }